import { createContext } from 'react';
import { Duvida } from 'api/Assessor/duvidas';

interface ChatContext {
  setDuvida: (value: Duvida | undefined) => void;
  duvidaAtual?: Duvida;
  respostaPadraoResponse?: any;
  setRespostaPadraoResponse: (value?: any) => void;
}

export default createContext<ChatContext>({
  setDuvida: () => ({}),
  setRespostaPadraoResponse: () => ({}),
});
